import { Equipe } from './equipe';

export class Prestador {
    constructor( 
    public username?: string,
    public codigo?: string,
    public nome?: string,
    public nomeRazaoSocial?: string,
	public endereco?: string,
	public bairro?: string,
	public cidade?: string,
	public uf?: string,
	public cep?: string,
	public rg?: string,
	public orgaoEmissor?: string,
	public ufOrgaoEmissor?: string,
	public cnpj?: string,
	public email?: string,
	public rede?: string,
	public banco?: string,
	public agencia?: string,
	public contaCorrente?: string,
	public diaPagamento?: string,
	public remuneracao?: string,
	public telefone?: string,
	public telefone1?: string,
	public telefone2?: string,
	public celular?: string,
	public fax?: string,
	public tipoEstabelecimento?: string,
	public cro?: string,
	public ufCro?: string,
	public dataNacimento?: Date,
	public srvID?: string,
	public unitID?: string,
	public especialidades?: any,
	public equipe?: Equipe
    ){}
    }



// WEBPACK FOOTER //
// ./src/app/components/base/vo/prestador.ts